import { ScrollableContentPanel, StepIndicator, YStack } from '@frontend/web-react';
import type { ReactNode } from 'react';

const ONBOARDING_STEPS = [
  { id: 'createAccount', label: 'Create account' },
  { id: 'membership', label: 'Membership' },
  { id: 'moreAboutYou', label: 'More about you' },
] as const;

export const FRICTIONLESS_STEPS = [{ id: 'createAccount', label: 'Create account' }] as const;

type DefaultStepId = (typeof ONBOARDING_STEPS)[number]['id'];

export type OnboardingStep<TStepId extends string = string> = { id: TStepId; label: string };

type OnboardingPageWrapperProps<TStepId extends string = DefaultStepId> = {
  allCompleted?: boolean;
  children: ReactNode;
  currentStep: DefaultStepId | TStepId;
  steps?: ReadonlyArray<OnboardingStep<TStepId>>;
};

export const OnboardingPageWrapper = <TStepId extends string = DefaultStepId>({
  allCompleted,
  children,
  currentStep,
  steps,
}: OnboardingPageWrapperProps<TStepId>) => {
  const effectiveSteps = steps ?? ONBOARDING_STEPS;

  return (
    <ScrollableContentPanel containerClassName="bg-cream-100" contentWidth="max-w-xl w-full" justifyContent="start">
      <YStack gapY="xxl">
        <StepIndicator allCompleted={allCompleted} currentStep={currentStep} steps={effectiveSteps} />

        {children}
      </YStack>
    </ScrollableContentPanel>
  );
};
